
import React, { useEffect, useState } from 'react'
import Pagination from '../Paginations'
import { getReleaseStats } from '../../api/releaseStats';
import { useDebounce } from '../AdminDashboard/AdminAnalytics';
import { useQuery } from '@tanstack/react-query';
import { TrackStatsModal } from '../AdminDashboard/subcomponent/track_stats_modal';
function ReleaseStatsTable({setReleaseTracks,previewTitle, setPreviewTitle, searchQuery, uid}) {
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [sortBy, setSortBy] = useState('revenue');
    const [titleFilter, setTitleFilter] = useState('');
    const [minStreamsFilter, setMinStreamsFilter] = useState('');
    const [maxStreamsFilter, setMaxStreamsFilter] = useState('');
    const [minRevenueFilter, setMinRevenueFilter] = useState('');
    const [maxRevenueFilter, setMaxRevenueFilter] = useState('');
    const debouncedSearchQuery = useDebounce(searchQuery, 500); // 500ms debounce delay
    const [sortOrder, setSortOrder] = useState("desc")
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };
    const [upc, setUPC] = useState('')
    const queryOptions = {
        page: currentPage,
        limit,
        title: titleFilter,
        minStreams: minStreamsFilter ? parseInt(minStreamsFilter, 10) : undefined,
        maxStreams: maxStreamsFilter ? parseInt(maxStreamsFilter, 10) : undefined,
        minRevenue: minRevenueFilter ? parseInt(minRevenueFilter, 10) : undefined,
        maxRevenue: maxRevenueFilter ? parseInt(maxRevenueFilter, 10) : undefined,
        search: debouncedSearchQuery,
        sortBy,
        sortOrder,
    };
    const handleSortChange = (sortField) => {
        setSortBy(sortField);
        setSortOrder(sortBy === sortField && sortOrder === 'desc' ? 'asc' : 'desc'); // Toggle sort order
    };
    const { data: release_stats, isLoading: release_statsLoading, error, refetch } = useQuery({
        queryKey: ['releaseStats', uid || '', queryOptions], // Unique query key based on filters, pagination, etc.
        queryFn: () => getReleaseStats(uid || '', queryOptions),
        keepPreviousData: true, // Keep showing previous data while fetching new page
    });
    useEffect(()=> {
        setCurrentPage(1);
    }, [searchQuery])
    return (
        <>
            {
                (release_stats || release_statsLoading) ? (
                    <>
                        <div className="table-responsive mt-3">
                            <table className="table dash-table">
                                <thead>
                                    <tr>
                                        <td>
                                            <div className='table-sort' onClick={() => handleSortChange('title')}>
                                                Releases Title
                                                {
                                                    sortOrder === "asc" ? <i className="fi fi-ss-angle-small-down"></i>
                                                        : <i className="fi fi-ss-angle-small-up"></i>
                                                }
                                            </div>
                                        </td>
                                        <td>
                                            <div className='table-sort' onClick={() => handleSortChange('streams')}>
                                                Streams
                                                {
                                                    sortOrder === "asc" ? <i className="fi fi-ss-angle-small-down"></i>
                                                        : <i className="fi fi-ss-angle-small-up"></i>
                                                }
                                            </div>
                                        </td>
                                        <td>
                                            <div className='table-sort' onClick={() => handleSortChange('revenue')}>
                                                Revenue
                                                {
                                                    sortOrder === "asc" ? <i className="fi fi-ss-angle-small-down"></i>
                                                        : <i className="fi fi-ss-angle-small-up"></i>
                                                }
                                            </div>
                                        </td>
                                        <td>Action</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        release_statsLoading && (
                                        <tr>
                                            <td colSpan="4" className="text-center">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                            </td>
                                        </tr>
                                        )
                                    }
                                    {
                                        release_stats?.stats?.map((release, i) => (
                                            <tr key={i}>
                                                <td>
                                                    <div className="table-item">
                                                        {release.title}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="table-item">
                                                        {release.streams}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="table-item">
                                                        ${release?.revenue?.toFixed(2)}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="table-item">
                                                        <button
                                                            className='table-btn'
                                                            data-bs-toggle="modal"
                                                            data-bs-target='#tracksModal'
                                                            onClick={() => {
                                                                setUPC(release.upc)
                                                                setPreviewTitle(release.title)
                                                            }}
                                                        >Details</button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                        <TrackStatsModal upc={upc} previewTitle={previewTitle}/>
                        <Pagination currentPage={currentPage} totalPages={release_stats?.pagination?.totalPages || 0} handlePageChange={handlePageChange} />
                    </>
                ) : (
                    <div className="no-data">No Release Data Available</div>
                )
            }
        </>
    )
}
export default ReleaseStatsTable